//
import { SwiperSlide } from 'swiper/react';
import Slider from '../../../../components/UI/Slider/Slider';
// style
import style from './arsenal.module.css';

const Arsenal = ({ arsenalFilter }) => {
  return (
    <section className={style.content}>
      <div className="container">
        <div className="title">
          <h2>
            Наш игровой <span>арсенал</span>
          </h2>
          {/* <span>
            Выбери свою игру <b>.</b>
          </span> */}
        </div>
        <div className={style.card}>
          <Slider loop={true} navigation={true} autoplay={true}>
            {arsenalFilter.map((item) => (
              <SwiperSlide key={item.id}>
                <div className={style.box}>
                  <img src={`../imgs/arsenal/${item.img}`} alt="" />
                  <h3>{item.title}</h3>
                  <ul>
                    {item.desc.map((i) => (
                      <li key={i.id}>{i.title}</li>
                    ))}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};
export default Arsenal;
